import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `LineaGenetica`, method: 'GET', body: null, token: token})
}